import React from 'react';
import Router from 'Router/Router';

function App() {
  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
